export default class HeaderContactBadge {
    constructor($el) {
        this.$el = $el;
        this.$toggle = this.$el.querySelector('[data-header-contact-badge-toggle]');
        this.$info = this.$el.querySelector('.header-contact-badge__info');

        this.toggle = this.toggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.$toggle.addEventListener('click', this.toggle);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('resize', this.handleResize);
    }

    toggle(event) {
        if (window.innerWidth < 992) {
            return;
        }

        event.preventDefault();
        this.setOpen( ! this.$el.classList.contains('open'));
    }

    setOpen(isOpen) {
        this.$el.classList.toggle('open', isOpen);
        this.$toggle.setAttribute('aria-expanded', isOpen.toString());

        if (this.$info) {
            this.$info.setAttribute('aria-hidden', ( ! isOpen).toString());
        }
    }

    handleDocumentClick(event) {
        if (this.$el.classList.contains('open') && ! this.$el.contains(event.target)) {
            this.setOpen(false);
        }
    }

    handleKeydown(event) {
        if (event.key === 'Escape' && this.$el.classList.contains('open')) {
            this.setOpen(false);
            this.$toggle.focus();
        }
    }

    handleResize() {
        if (window.innerWidth < 992 && this.$el.classList.contains('open')) {
            this.setOpen(false);
        }
    }
}
